import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import NavBar from "../../features/nav/NavBar/NavBar";
import SystemNoticesGate from "../common/systemNotices/SystemNoticesGate";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import HomePage from "../../../src/features/pages/HomePage";
import ContactUsPage from "../../../src/features/pages/ContactUsPage";
import LegalPage from "../../../src/features/pages/LegalPage";
import PaymentErrorPage from "../../../src/features/pages/PaymentErrorPage";
import Footer from "../../features/nav/Footer";
import PrivateRoute from "./PrivateRoute";

import AboutUsPage from "../../features/pages/AboutUsPage";
import ProductsPage from "../../features/pages/ProductsPage";
import ServicesPage from "../../features/pages/ServicesPage";
import OnlineOrderingPage from "../../features/pages/OnlineOrderingPage";

import WarehousingDistributionPage from "../../features/pages/services/WarehousingDistributionPage";
import WholesalePage from "../../features/pages/services/WholesalePage";
import LogisticsPage from "../../features/pages/services/LogisticsPage";
import RepackingPage from "../../features/pages/services/RepackingPage";

import HowToOpenAnAccountPage from "../../features/pages/onlineOrdering/HowToOpenAnAccountPage";
import TipsToImproveOrderingPage from "../../features/pages/onlineOrdering/TipsToImproveOrderingPage";
import HowToOrderPage from "../../features/pages/onlineOrdering/HowToOrderPage";

// import ShopPage from "../../features/pages/admin/ShopPage";
import ShopPage from "../../features/pages/admin/shopCategories/ProductPageNew";

import ModalManager from "../common/modals/ModalManager";
import ProductPage from "../../features/pages/admin/shopCategories/ProductPage";
import Promotions from "../../features/pages/admin/shopCategories/Promotions";
import Orders from "../../features/pages/admin/shopCategories/Orders";
import BackOrders from "../../features/pages/admin/shopCategories/BackOrders";
import Statements from "../../features/pages/admin/shopCategories/Statements";
import SpecificOrder from "../../features/pages/admin/shopCategories/SpecificOrder";
import Favourites from "../../features/pages/admin/shopCategories/Favourites";
import { Account } from "../../features/pages/admin/Account";
import { Enquiries } from "../../features/pages/admin/Enquiries";
import { CustomCodes } from "../../features/pages/admin/CustomCodes";
import { CustomCodeEdit } from "../../features/pages/admin/CustomCodeEdit";
import Cart from "../../features/pages/admin/Users/Cart";
import { UserManagement } from "../../features/pages/admin/Users/UserManagement";
import { Reports } from "../../features/pages/admin/Users/Reports";
import { EditUser } from "../../features/pages/admin/Users/EditUser";
import SearchPage from "../../features/pages/admin/shopCategories/SearchPage";
import { EnquiriesHistory } from "../../features/pages/admin/Users/EnquiriesHistory";
import { EnquiriesView } from "../../features/pages/admin/Users/EnquiriesView";
import { PromotionManagement } from "../../features/pages/admin/Users/PromotionManagement";
import { EditPromotion } from "../../features/pages/admin/Users/EditPromotion";
import OrderTemplates from "../../features/pages/admin/shopCategories/OrderTemplates";
import SpecificTemplate from "../../features/pages/admin/shopCategories/SpecificTemplate";
import { SelectAccount } from "../../features/pages/admin/SelectAccount";
import ResetPassword from "../../features/forms/ResetPassword";
import SystemSettings from "../../features/pages/admin/SystemSettings";
import { AdminDashboard } from "../../features/pages/admin/AdminDashboard";
import { PaymentsReport } from "../../features/pages/admin/PaymentsReport";
import { SysproOrderLog } from "../../features/pages/admin/SysproOrderLog";
import { AdminProductCategories } from "../../features/pages/admin/productCategories/productCategories";
import { AdminProducts } from "../../features/pages/admin/products/products";
import { AdminProductTags } from "../../features/pages/admin/products/productTags";
// import { useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import AdminNavBar from "../../features/nav/NavBar/AdminNavBar";

export default function App() {
  // const { currentUser } = useSelector((state) => state.auth);
  // const location = useLocation();
  // const isSelectProfilePage = location.pathname.includes("select-profile");

  // useEffect(() => {
  //       console.log("======================location=========================== ", location.pathname.includes("select-profile"));

  //   if (!currentUser?.branch || isSelectProfilePage) {
  //         // Remove old script if it exists
  //     const existingScript = document.getElementById("tawk-script");
  //     if (existingScript) {
  //       existingScript.remove();
  //       window.location.reload();
  //       //teardownTawk();
  //     }

  //     return;
  //   }
  //   console.log("++++++++++++++++++++++current user+++++++++++++++++++++++", currentUser);



  //   const timeout = setTimeout(() => {
  //     const lastBranch = sessionStorage.getItem("tawk-branch");
  //     const currentBranch = currentUser.branch;

  //     // If branch hasn't changed, keep existing chat
  //     if (lastBranch === currentBranch) {
  //       return;
  //     }

  //     // Remove old script if it exists
  //     const existingScript = document.getElementById("tawk-script");
  //     if (existingScript) {
  //       existingScript.remove();
  //     }

  //     // Reset Tawk API if needed
  //     if (window.Tawk_API) {
  //       window.Tawk_API = undefined;
  //       console.log("Tawk API reset");
  //     }
  //     let scriptSrc = "";

  //     if (currentBranch === "06") { // Port Elizabeth
  //       scriptSrc = "https://embed.tawk.to/68b012a67190b01921567826/1j3nshmtd";
  //     } else if (currentBranch === "01") { // JOBURG
  //       scriptSrc = "https://embed.tawk.to/68932b54ddd4a01926701cf0/1j1ve2gjq";
  //     } else if (currentBranch === "03") { // PIETERMARITZBURG
  //       scriptSrc = "https://embed.tawk.to/68b2cf44109d7be2aa210d3b/1j3t7j90n";
  //     } else if (currentBranch === "02" || currentBranch === "05") { // CAPE TOWN & GEORGE
  //       scriptSrc = "https://embed.tawk.to/68b2cfce46bc0d230c3428af/1j3t7ngef";
  //     }

  // if (scriptSrc) {
  //       const s1 = document.createElement("script");
  //       s1.id = "tawk-script";
  //       s1.async = true;
  //       s1.src = scriptSrc;
  //       s1.charset = "UTF-8";
  //       s1.setAttribute("crossorigin", "*");

  //       document.body.appendChild(s1);

  //       // Store branch
  //       sessionStorage.setItem("tawk-branch", currentBranch);

  //       // Define API callback BEFORE widget loads
  //       window.Tawk_API = window.Tawk_API || {};
  //       window.Tawk_API.onLoad = function () {
  //         console.log("✅ Tawk loaded, setting attributes...");
  //         window.Tawk_API.setAttributes(
  //           {
  //             name: currentUser?.name || "Guest",
  //             email: currentUser?.email || "no-email",
  //             clientNumber: currentUser?.clientNumber || "N/A",
  //           },
  //           (error) => {
  //             if (error) console.error("❌ Tawk setAttributes error:", error);
  //             else console.log("✅ Attributes set!");
  //           }
  //         );
  //       };
  //     }
  //   }, 100);

  //   return () => clearTimeout(timeout);
  // }, [currentUser?.branch,isSelectProfilePage]);

  //   const teardownTawk = () => {
  //     console.log("Tearing down Tawk...");

  //     try {
  //       if (window.Tawk_API) {
  //         window.Tawk_API.hideWidget();
  //         window.Tawk_API.endChat();
  //       }
  //     } catch (err) {
  //       console.warn("Tawk API not ready:", err);
  //     }

  //     // Remove script
  //     const script = document.getElementById("tawk-script");
  //     if (script) script.remove();

  //     // Remove iframe & divs
  //     document.querySelectorAll("iframe[src*='tawk.to']").forEach(el => el.remove());
  //     document.querySelectorAll("div[id^='tawk']").forEach(el => el.remove());

  //     // Reset globals
  //     window.Tawk_API = undefined;
  //     window.Tawk_LoadStart = undefined;
  //   };
  return (
    <>
      <ModalManager />
      <SystemNoticesGate />
      <NavBar />

      <Route
        path={"/"}
        render={() => (
          <>
            <Route exact path="/" component={HomePage} />
            <Route path="/reset-password/:token" component={ResetPassword} />
            <Route path="/about-us" component={AboutUsPage} />
            <Route path="/products" component={ProductsPage} />
            <Route exact path="/services" component={ServicesPage} />
            <Route exact path="/services/wholesale" component={WholesalePage} />
            <Route exact path="/services/warehousing-and-distribution" component={WarehousingDistributionPage} />
            <Route exact path="/services/repacking" component={RepackingPage} />
            <Route exact path="/services/logistics" component={LogisticsPage} />
            <Route exact path="/online-ordering" component={OnlineOrderingPage} />
            <Route exact path="/online-ordering/how-to-open-an-account" component={HowToOpenAnAccountPage} />
            <Route exact path="/online-ordering/tips-to-improve-ordering" component={TipsToImproveOrderingPage} />
            <Route exact path="/online-ordering/how-to-order" component={HowToOrderPage} />
            <Route path="/contact-us" component={ContactUsPage} />
            <Route path="/legal" component={LegalPage} />
            <Route path="/payment-error" component={PaymentErrorPage} />
            {/* Protected navigation */}
            {/* <AdminNavBar /> */}
            <PrivateRoute path="/shop" component={ShopPage} />
            <PrivateRoute path="/shop-companion-animal-pharmaceuticals" component={ProductPage} />
            <PrivateRoute path="/shop-poultry-pharmaceuticals" component={ProductPage} />
            <PrivateRoute path="/shop-diagnostics" component={ProductPage} />
            <PrivateRoute path="/shop-large-animal-pharmaceuticals" component={ProductPage} />
            <PrivateRoute path="/shop-equine-pharmaceuticals" component={ProductPage} />
            <PrivateRoute path="/shop-wildlife-pharmaceuticals" component={ProductPage} />
            <PrivateRoute path="/shop-human-pharmaceuticals-used-in-veterinary-practice" component={ProductPage} />
            <PrivateRoute path="/shop-cold-chain-biologicals" component={ProductPage} />
            <PrivateRoute path="/shop-surgicals" component={ProductPage} />
            <PrivateRoute path="/shop-instruments" component={ProductPage} />
            <PrivateRoute path="/shop-disposables" component={ProductPage} />
            <PrivateRoute path="/shop-premium-pet-foods" component={ProductPage} />
            <PrivateRoute path="/shop-pet-accessories" component={ProductPage} />
            <PrivateRoute path="/shop-veterinary-retail-products" component={ProductPage} />
            <PrivateRoute path="/shop-favourites" component={Favourites} />
            <PrivateRoute path="/promotions" component={Promotions} />
            <PrivateRoute path="/orders" component={Orders} />
            <PrivateRoute path="/order/:orderId" component={SpecificOrder} />
            <PrivateRoute path="/backorders" component={BackOrders} />
            <PrivateRoute path="/statements" component={Statements} />
            <PrivateRoute path="/account" component={Account} />
            <PrivateRoute path="/enquiries" component={Enquiries} />
            <PrivateRoute path="/custom_codes" component={CustomCodes} />
            <PrivateRoute path="/edit_custom_codes/:custom_code_id" component={CustomCodeEdit} />
            <PrivateRoute path="/view-cart" component={Cart} />
            <PrivateRoute path="/user-management" component={UserManagement} />
            <PrivateRoute path="/reports" component={Reports} />
            <PrivateRoute path="/edit/user/:userId" component={EditUser} />
            <PrivateRoute path="/enquiries-history" component={EnquiriesHistory} />
            <PrivateRoute path="/enquiries-view/:enquiryId" component={EnquiriesView} />
            <PrivateRoute path="/promotion-management" component={PromotionManagement} />
            <PrivateRoute path="/edit/promotion/:promotionID" component={EditPromotion} />
            <PrivateRoute path="/order-templates" component={OrderTemplates} />
            <PrivateRoute path="/template/:templateID" component={SpecificTemplate} />
            <PrivateRoute path="/search-results" component={SearchPage} />
            <PrivateRoute path="/select-profile" component={SelectAccount} />
            <PrivateRoute path="/system-settings" component={SystemSettings} />
            <PrivateRoute path="/admin-dashboard" component={AdminDashboard} />
            <PrivateRoute path="/admin/payments-report" component={PaymentsReport} />
            <PrivateRoute path="/admin/syspro-order-log" component={SysproOrderLog} />
            <PrivateRoute path="/admin/product-categories" component={AdminProductCategories} />
            <PrivateRoute path="/admin/products" component={AdminProducts} />
            <PrivateRoute path="/admin/product_tags" component={AdminProductTags} />
            {/* <Route path="/error" component={NotFound} /> */}
          </>
        )}
      />
      <Footer />
    </>
  );
}
